import { Flex, FormControl } from '@chakra-ui/react'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'

import { FormLabel } from '../../components/FormLabel'
import { Switch } from '../../components/Switch'
import { SwitchControl } from '../../components/SwitchControl'

interface NewsFilterFormValues {
  company: string
  priority: string
  unreadOnly: boolean
}

export const NewsFilterForm = ({
  unreadOnly,
  onUnreadOnlyChange,
}: {
  unreadOnly: boolean
  onUnreadOnlyChange: Function
}) => {
  const methods = useForm<NewsFilterFormValues>({
    defaultValues: {
      unreadOnly,
    },
  })
  const {
    handleSubmit,
    register,
    // formState: { errors, isSubmitting },
  } = methods

  const onSubmit = (values: NewsFilterFormValues) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, 500)
    })
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex>
          <FormControl>
            <FormLabel>Filtrovat</FormLabel>

            <Flex sx={{ gap: 4, flexWrap: 'wrap' }}>
              {/* <CompaniesSelect {...register('company')} /> */}

              {/* <Select {...register('priority')}>
                <option value="">Dle priority</option>
              </Select> */}

              <SwitchControl>
                <Switch
                  size="md"
                  id="unreadOnly"
                  {...register('unreadOnly')}
                  onChange={(event) => {
                    onUnreadOnlyChange(event.target.checked)
                  }}
                />
                <FormLabel htmlFor="unreadOnly" variant="switch">
                  Pouze nepřečtené
                </FormLabel>
              </SwitchControl>
            </Flex>
          </FormControl>
        </Flex>
      </form>
    </FormProvider>
  )
}
